// src/factories/commentFactory.ts
import { type Comment } from '@/types/Comment'

/**
 * Creates a new Comment with default values
 */
export function createComment(data: Partial<Comment> = {}): Comment {
  const now = new Date()

  return {
    id: data.id ?? crypto.randomUUID(),
    content: data.content ?? '',
    organizationId: data.organizationId,
    personId: data.personId,
    taskId: data.taskId,
    transactionId: data.transactionId,
    createdBy: data.createdBy,
    createdAt: data.createdAt instanceof Date ? data.createdAt : now,
    updatedAt: data.updatedAt instanceof Date ? data.updatedAt : now,
  }
}
